export enum EPowerMeasureType {
  WATT = "WATT",
  KILO_WATT = "KILO_WATT",
  MEGA_WATT = "MEGA_WATT",
  GIGA_WATT = "GIGA_WATT",
}
